import { Box } from "@mui/material";
import { CheckoutContext } from "contexts/Checkout";
import { useContext } from "react";
import { AddOnItemName } from "schemas/dashboard";

import { useCheckout } from "components/StripeCheckout/useCheckout";

import SeeExample from "../SeeExample";
import AddOnCard from "./AddOnCard";

const PartnershipDataBundle = () => {
  const { addOnItems, applyAddOnLoading } = useContext(CheckoutContext);
  const { applyAddOnItem } = useCheckout();

  const exists = addOnItems?.find(
    (x) => x.name === AddOnItemName.partnership_data,
  );

  return (
    <AddOnCard
      icon="fa-regular fa-database"
      title="Partnership Data"
      priceText="$8.00"
      per="/mo"
      tag="Bundle"
      description="See if they pay or just offer gifted products, when they last collaborated, where they operate, and if their contacts are verified or responsive."
      extra={
        <>
          <Box sx={{ fontSize: 11.5, fontWeight: 700, color: "purple.main" }}>
            SAVE 20%
          </Box>
          <SeeExample />
        </>
      }
      loading={applyAddOnLoading === AddOnItemName.partnership_data}
      quantity={exists ? 1 : 0}
      onAdd={() =>
        applyAddOnItem({ name: AddOnItemName.partnership_data, quantity: 1 })
      }
      onRemove={() =>
        applyAddOnItem({ name: AddOnItemName.partnership_data, quantity: 0 })
      }
    />
  );
};

export default PartnershipDataBundle;
